module.exports = __webpack_public_path__ + "img/title_1.2448fd51.png";